import styled from "styled-components";

export const SingleNftWrapper = styled.div`
  margin: 30px 0 50px;
`;

export const SingleNftMain = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  @media (max-width: 991.98px) {
    flex-direction: column;
  }
`;

export const SingleNftMainImg = styled.div`
  width: 55%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 10px 20px 10px 0;
  & img {
    object-fit: 1/1;
    width: 100%;
    height: auto;
  }
  @media (max-width: 991.98px) {
    width: 100%;
    padding: 10px 0;
  }
`;

export const SingleNftMainRight = styled.div`
  width: 45%;
  padding: 10px 10px 10px 50px;
  @media (max-width: 991.98px) {
    width: 100%;
    padding: 10px 0;
  }
`;
